import { useTranslation } from 'react-i18next';

import { VoiceInput } from '../../voice/components/VoiceInput';
import { TaskForm, type TaskFormValues } from '../components/TaskForm';
import { TaskQuotaNotice } from '../components/TaskQuotaNotice';
import { useCreateTask } from '../hooks/useCreateTask';
import { getTaskLimit } from '../lib/quotaError';
import styles from './TaskFormScreen.module.css';

interface TaskFormScreenProps {
  onClose: () => void;
  onOpenBilling: () => void;
}

// PARA-128 (FE-8) — экран создания задачи: TaskForm + useCreateTask;
// успех → возврат в бэклог (AC-1/AC-2), ошибка мутации маппится в форму (AC-E2).
// PARA-131 (AC-15) — 402 «достигнут лимит» показывается отдельным сообщением с
// переходом к тарифам, а не общей ошибкой формы. Хук useCreateTask не меняется:
// useMutation уже отдаёт error наружу, распознавание — в guard'е getTaskLimit.
export function TaskFormScreen({ onClose, onOpenBilling }: TaskFormScreenProps): JSX.Element {
  const { t } = useTranslation('tasks');
  const { mutate, isPending, isError, error } = useCreateTask();

  const taskLimit = getTaskLimit(error);

  // PARA-135 (AC-29, AC-30) — оценка длительности уезжает в POST /tasks:
  // backend принимает её с Группы AC 7. Тело собирается явно, чтобы состав
  // запроса был виден в одном месте и не зависел от формы TaskFormValues.
  const handleSubmit = ({
    title,
    size,
    priority,
    estimatedDurationMinutes,
  }: TaskFormValues): void => {
    mutate(
      { title, size, priority, estimated_duration_minutes: estimatedDurationMinutes },
      { onSuccess: onClose },
    );
  };

  return (
    <div className={styles.screen}>
      <h2 className={styles.heading}>{t('form.createTitle')}</h2>
      {taskLimit !== null && (
        <div className={styles.quota}>
          <TaskQuotaNotice taskLimit={taskLimit} onOpenBilling={onOpenBilling} />
        </div>
      )}
      <TaskForm
        submitLabel={t('form.submitCreate')}
        onSubmit={handleSubmit}
        onCancel={onClose}
        isPending={isPending}
        error={isError && taskLimit === null ? t('form.errors.submitFailed') : null}
        renderVoiceInput={(api) => <VoiceInput {...api} onOpenBilling={onOpenBilling} />}
      />
    </div>
  );
}
